import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-advantages-of-bba-degree',
  templateUrl: './advantages-of-bba-degree.component.html',
  styleUrls: ['./advantages-of-bba-degree.component.scss']
})
export class AdvantagesOfBbaDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  ngOnInit(): void {
  }

}
